export default "__VITE_PUBLIC_ASSET__beca34b8__"